import React, { useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import { Modal, Button, Col } from "react-bootstrap";
import services from 'API/services';
import VerifiedInput from 'pages/propertydetails/VerifiedInput';
import { ErrorMessage } from "@hookform/error-message";
import { InputField } from "../../components/InputField/InputField";
import LegalEntityPopup from './LegalEntityPopup';

export const OwnerShipModal = ({ propertyName, propertyId, show, setShowOwnerModal, userDetail }) => {


  const [data, setData] = useState({});
  const [showLegal, setShowLegal] = useState(false)

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors }
  } = useForm();

  const [showVerify, setShowVerify] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [showLoadButton, setShowLoadButton] = useState(false);
  const [ownerData, setOwnerData] = useState(null);
  const [newProperty, setNewProperty] = useState({})

  const { phoneNumber, email } = watch();

  const fetchData = async () => {
    const res = await services.property.getPropertyCategoryServiceId(propertyId);
    if (res?.status === 200) {
      setData(res?.data?.data)
    }
  }
  useEffect(() => {
    if (propertyId) {
      fetchData()
    }
  }, [propertyId])

  useEffect(() => {
    setValue("firstName", data.ownerFirstName);
    setValue("lastName", data.ownerLastName);
    setValue("panNumber", data.ownerPan);
    setValue("adharNumber", data.ownerAdhar);
    setValue("email", data.ownerEmail);
    setValue("phoneNumber", data.ownerMobile);
  }, [data])

  const onSubmit = async (payload) => {
    let bodyFormData1 = new FormData();
    bodyFormData1.append("name", propertyName);
    bodyFormData1.append("address", data?.address);
    bodyFormData1.append("propertyCategoryId", data?.propertyCategoryId);
    bodyFormData1.append("latitude", data?.latitude);
    bodyFormData1.append("longitude", data?.longitude);
    bodyFormData1.append("ownerFirstName", payload?.firstName);
    bodyFormData1.append("ownerLastName", payload?.lastName);
    bodyFormData1.append("ownerMobile", payload?.phoneNumber);
    bodyFormData1.append("ownerEmail", payload?.email);
    bodyFormData1.append("ownerPan", payload?.panNumber);
    bodyFormData1.append("ownerAdhar", payload?.adharNumber);
    bodyFormData1.append("pincode", data?.pincode);
    bodyFormData1.append("countryId", "IN");
    bodyFormData1.append("city", data?.cityId);
    bodyFormData1.append("noOfRooms", data?.noOfRooms);
    bodyFormData1.append("stateId", data?.stateId);
    bodyFormData1.append("propertyDescription", data?.propertyDescription);
    bodyFormData1.append("propertyMobileNumber", payload?.propertyPhone);
    bodyFormData1.append("propertyEmailId", payload?.propertyEmail);
    bodyFormData1.append("landmark", data?.landmark);
    bodyFormData1.append("bookingPolicy", data?.bookingPolicy);
    bodyFormData1.append("locaidAccept", data?.Local ? 1 : 0);
    bodyFormData1.append("coupleFriendly", data?.Couple ? 1 : 0);
    bodyFormData1.append("partialPayment", data?.Partial ? 1 : 0);
    bodyFormData1.append("status", 0);
    bodyFormData1.append("locality", data?.locality);
    bodyFormData1.append("travellerChoice", data?.travellerChoice);
    bodyFormData1.append("createdBy", userDetail?.id);

    bodyFormData1.append("onboardedRooms", data?.onboardedRooms);
    bodyFormData1.append("roomsCommission", data?.roomsCommission);
    bodyFormData1.append("hub", data?.hub?.id);
    bodyFormData1.append("zone", data?.zone);

    bodyFormData1.append("haveBanquateLawan", data?.haveBanquateLawan);
    bodyFormData1.append("havelawn", data?.havelawn);
    bodyFormData1.append("haveRestaurent", data?.haveRestaurent);
    bodyFormData1.append("haveBar", data?.haveBar);
    bodyFormData1.append("haveRoofTop", data?.haveRoofTop);
    bodyFormData1.append("haveConferenceRoom", data?.haveConferenceRoom);
    bodyFormData1.append("place_id", data?.place_id);
    bodyFormData1.append("allowHourly", data?.allowHourly);

    const res = await services.property.createRRoomPropertyService(bodyFormData1);
    if (res?.data?.status == true) {
      let newPropertyId = res?.data?.data?.id

      ownerTransfered(propertyId, newPropertyId)
      setNewProperty(res?.data?.data)
      setShowOwnerModal(false)
      setShowLegal(true)
    }
  }

  useEffect(() => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isPhoneValid = /^[0-9]{10}$/.test(phoneNumber);

    const checkOwner = async () => {
      if ((isEmailValid || isPhoneValid) && !apiCalled) {
        const payload = {
          ownerMobile: phoneNumber,
          ownerEmail: email
        };
        try {
          let res = await services.property.checkOwnerExistService(payload);
          if (res.data.status === false) {
            setValue("firstName", '');
            setValue("lastName", '');
            setValue("panNumber", '');
            setValue("adharNumber", '');
            // if (!isEmailValid) setValue("email", '');
            if (!phoneNumber) setValue("phoneNumber", '');
            setShowLoadButton(false);
            setOwnerData(null);
            setShowVerify(true)
          }
          if (res.data.status === true) {
            let owner = res.data.data
            setValue("firstName", owner.firstName);
            setValue("lastName", owner.lastName);
            setValue("panNumber", owner.ownerPan);
            setValue("adharNumber", owner.ownerAdhar);
            setValue("phoneNumber", owner.mobile);
            if (!editMode) {
              setValue("email", owner.email);
            }

            // setOwnerData(res.data.data);
            setShowLoadButton(true);
            setShowVerify(false)
          }

          setApiCalled(true);
        } catch (error) {
          console.error("API error:", error);
        }
      }
    };

    checkOwner();
  }, [phoneNumber, email]);

  useEffect(() => {
    setApiCalled(false);
  }, [phoneNumber, email]);

  const removeExsitOwner = () => {
    setValue("firstName", '');
    setValue("lastName", '');
    setValue("panNumber", '');
    setValue("adharNumber", '');
    setValue("phoneNumber", '');
    setValue("email", '');
    setShowLoadButton(false)
  }

  const ownerTransfered = async (id, newPropertyId) => {
    const payload = {
      propertyId: id,
      userId: userDetail?.id,
      newPropertyId: newPropertyId
    }
    const res = await services.property.ownershipTransferService(payload)
  }

  return (
    <>
      <Modal size='lg' show={show} onHide={() => setShowOwnerModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Ownership Transfer</Modal.Title>
        </Modal.Header>

        <Modal.Body className='p-4'>
          <form className='row' onSubmit={handleSubmit(onSubmit)}>
            <Col xs={12} className="mt-2 mb-2">
              <h6 style={{ fontSize: '12px' }}>
                {showLoadButton && (
                  <span type="button" className="text-danger text-default">
                    This owner is already registered. <span onClick={removeExsitOwner} style={{ textDecoration: 'underline' }}>Please select a different owner to proceed.</span>
                  </span>
                )}
              </h6>
            </Col>
            <Col xs={6} className="form-group">
              <VerifiedInput
                label="Property Email"
                placeholder="Enter Property Email"
                fieldName="propertyEmail"
                isEmail={true}
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}
                notValid={true}
                verifyService={services.property.verifyEmailIdService}
                editMode={editMode}
              />
              {errors?.propertyEmail?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage
                      errors={errors}
                      name={"propertyEmail"}
                    />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <VerifiedInput
                label="Property Phone"
                placeholder="Enter Property Phone"
                fieldName="propertyPhone"
                isEmail={false}
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}
                notValid={true}
                verifyService={services.property.verifyPhoneNumberService}
                editMode={editMode}
              />
              {errors?.propertyPhone?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage
                      errors={errors}
                      name={"propertyPhone"}
                    />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <VerifiedInput
                label="Contact No. *"
                placeholder="Enter phone number"
                fieldName="phoneNumber"
                isEmail={false}
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}
                notValid={showVerify}
                verifyService={services.property.verifyPhoneNumberService}
                editMode={editMode}
              />

              {errors?.phoneNumber?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage errors={errors} name={"phoneNumber"} />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <VerifiedInput
                label="Email ID"
                placeholder="Enter email address"
                fieldName="email"
                isEmail={true}
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}
                notValid={showVerify}
                verifyService={services.property.verifyEmailIdService}
                editMode={editMode}
              />
            </Col>

            <Col xs={6} className="form-group">
              <InputField
                htmlFor="firstName"
                text="First Name"
                type="text"
                placeholder="Enter first name"
                field={"firstName"}
                register={register}
                errors={errors}
              />
              {errors?.firstName?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage errors={errors} name={"firstName"} />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <InputField
                htmlFor="lastName"
                text="Last Name"
                type="text"
                placeholder="Enter Last name"
                field={"lastName"}
                register={register}
                errors={errors}
              />
              {errors?.lastName?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage errors={errors} name={"lastName"} />
                  </span>
                </div>
              )}
            </Col>
            <Col xs={6} className="form-group">
              <InputField
                htmlFor="panNumber"
                text="PAN No.*"
                type="text"
                placeholder="Enter PAN number"
                field={"panNumber"}
                register={register}
                errors={errors}
              />
              {errors?.panNumber?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage errors={errors} name={"panNumber"} />
                  </span>
                </div>
              )}
            </Col>

            <Col xs={6} className="form-group">
              <InputField
                htmlFor="adharNumber"
                text="Aadhar No. *"
                type="text"
                placeholder="Enter adhar number"
                field={"adharNumber"}
                register={register}
                errors={errors}
                max={12}
              />
              {errors?.adharNumber?.message && (
                <div className="error-text">
                  <span>
                    <ErrorMessage errors={errors} name={"adharNumber"} />
                  </span>
                </div>
              )}
            </Col>
            <Button type='submit' variant="primary">
              Save
            </Button>
          </form>
        </Modal.Body>
      </Modal>


      <LegalEntityPopup data={data} newData={newProperty} showLegal={showLegal} setShowLegal={setShowLegal} />
    </>
  )
}
